export default function SeoFaqSection({ items = [] }) {
  if (!items.length) return null;

  return (
    <section className="seo-faq" aria-labelledby="seo-faq-heading">
      <h2 id="seo-faq-heading">Preguntas frecuentes</h2>
      <div className="seo-faq__list">
        {items.map((item) => (
          <details key={item.question} className="seo-faq__item">
            <summary>{item.question}</summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
